import { safeParseNullDefault } from 'shouldve-been-js';

class Country {

    private _code: string;
    private _name: string;

    public constructor(code: string, name: string) {

        this._code = code;
        this._name = name;
    }

    public get code(): string {
        return this._code;
    }

    public set code(value: string) {
        this._code = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Country | null {

        const code: string | null = safeParseNullDefault<string>(json?.code, '');
        const name: string | null = safeParseNullDefault<string>(json?.name, '');
        
        if (code === null || name === null || code === '' || name === '') {
            return null;
        }

        return new Country(code, name);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): Country | null {

        const code: string | null = safeParseNullDefault<string>(object?._code, '');
        const name: string | null = safeParseNullDefault<string>(object?._name, '');
        
        if (code === null || name === null || code === '' || name === '') {
            return null;
        }

        return new Country(code, name);
    }
}

export default Country;